<template lang="html">
    <div class="main-form">
        <div class="main-form__logo">
            <img src="@/assets/images/logo.svg" alt="Nexyo Logo">
        </div>
        <div class="main-form__container">
            <div class="main-form__title">
                Creează cont
            </div>

        <div v-if="apiErrors" class="main-form__text">
            <span v-if="typeof apiErrors == 'string'" class="error">
                {{apiErrors}}<br>
            </span>
            <span v-else-if="typeof apiErrors == 'object'"
                v-for="error in apiErrors" :key="error" class="error">
                {{error}}<br>
            </span>
        </div>

        <UiInput
            label="Nume"
            placeholder="Popescu"
            :value="firstName"
            :disabled="isLoading"
            :error="errors.firstName"
            @input="firstName = $event, validateFirstName()"
            @blur="validateFirstName"
            @keyup="loginOnEnter"
        />

        <UiInput
            label="Prenume"
            placeholder="Andrei"
            :value="lastName"
            :disabled="isLoading"
            :error="errors.lastName"
            @input="lastName = $event, validateLastName()"
            @blur="validateLastName"
            @keyup="loginOnEnter"
        />

        <UiInput
            label="Adresă de email"
            type="email"
            placeholder="user@gmail.com"
            :value="email"
            :disabled="isLoading"
            :error="errors.email"
            @input="email = $event, validateEmail()"
            @blur="validateEmail"
            @keyup="loginOnEnter"
        />

        <!--
        <UiSelectDate
            label="Data nașterii"
            :error="errors.dob"
            :disabled="isLoading"
            min="1971"
            max="2010"
            @input="dob = $event"
        />
        -->

        <UiInput
            label="Parolă"
            type="password"
            icon="fa fa-lock"
            :error="errors.password"
            :disabled="isLoading"
            @input="password = $event, validatePassword()"
            @blur="validatePassword"
            @keyup="loginOnEnter"
        />

        <UiCheckbox
            :id="1"
            @input="checkbox = $event"
            :tos="true"
        />

        <UiCheckbox
            :id="2"
            @input="checkboxAge = $event"
            :label="'Confirm că am peste 18 ani.'"
        />

        <UiButton
            shape="square"
            name="Continua"
            :disabled="disabledButton"
            :name="isLoading ? 'Se crează contul...' : 'Continuă'"
            @click="sendRegister"
        />
        <router-link to="/login" tag="span">
            <div class="main-form__subtext">
                Ai deja un cont? <a>Intra in platforma!</a>
            </div>
        </router-link>

        <SocialAuth @clearForm="clearForm" v-if="role === 'client'" />

        </div>
        <div class="main-form__empty"></div>
    </div>
</template>

<script>

import UiInput from '@/components/ui/Input'
import UiCheckbox from '@/components/ui/Checkbox.vue'
import UiButton from '@/components/ui/Button'
import UiSelectDate from '@/components/ui/SelectDate.vue';

import SocialAuth from '@/pages/SocialAuth.vue'

import { mapActions } from 'vuex'
import { mapGetters } from 'vuex'

export default {
    components: {
        UiInput,
        UiCheckbox,
        UiButton,
        UiSelectDate,
        SocialAuth
    },
    data() {
        return {
            firstName: '',
            lastName: '',
            email: '',
            password: '',
            passwordConfirmation: '',
            dob: '',
            checkbox: false,
            checkboxAge: false,
            errors: {
                firstName: '',
                lastName: '',
                email: '',
                dob: '',
                password: ''
            },
            apiErrors: null,
            isLoading: false
        }
    },
    created() {
        if(this.$router.currentRoute.fullPath == '/specialist/login')
            this.role = 'specialist';
        else
            this.role = 'client';
    },
    methods: {
        ...mapActions({
            register: 'user/register'
        }),
        validateDob(value) {
            this.errors = null;
            var date = new Date(value);
            if(date.getTime() >= new Date().getTime()) {
                this.errors = 'Data de naștere invalidă'
                return;
            }
            var year = date.getFullYear();
            var month = date.getMonth()+1;
            var day = date.getDate();
            this.dob = year+'-'+month+'-'+day;
        },
        loginOnEnter(event) {
            if (event.keyCode === 13) {
                this.sendRegister();
            }
        },
        sendRegister() {
            if(this.disabledButton === false) {
                this.isLoading = true;
                var data = {
                    firstName: this.firstName,
                    lastName: this.lastName,
                    email: this.email,
                    password: this.password,
                    passwordConfirmation: this.password,
                    dob: this.dob
                }
                this.register(data);

                this.errors.firstName = '';
                this.errors.lastName = '';
                this.errors.email = '';
                this.errors.password = '';
                this.errors.passwordConfirmation = '';
                this.errors.dob = '';
                this.apiErrors = null;
            }
        },
        validateEmailFormat(email) {
            const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        },
        validateFirstName() {
            this.apiErrors = null;
            if(this.firstName.length > 0 && this.firstName.length < 3 || this.firstName.length > 30)
                this.errors.firstName = 'Numele trebuie să conțina minim 3 si maxim 30 de caractere';
            else this.errors.firstName = '';
        },
        validateLastName() {
            this.apiErrors = null;
            if(this.lastName.length > 0 && this.lastName.length < 3 || this.lastName.length > 30)
                this.errors.lastName = 'Prenumele trebuie să conțină minim 3 si maxim 30 de caractere';
            else this.errors.lastName = '';
        },
        validateEmail() {
            this.apiErrors = null;
            if(this.email.length > 0 && !this.validateEmailFormat(this.email))
                this.errors.email = 'Adresa de email introdusă este invalidă!';
            else this.errors.email = '';
        },
        validatePassword() {
            this.apiErrors = null;
            if(this.password.length > 0 && this.password.length < 6)
                this.errors.password = 'Parola trebuie să contina minim 6 caractere';
            else {
                this.errors.password = '';
            }
        },
        clearForm() {
            this.email = ''; this.password = '';
            this.errors = {
                firstName: '', lastName: '',
                email: '', dob: '', password: ''
            };
            this.apiErrors = null;
            this.firstName = ''; this.lastName = '';
            this.email = ''; this.password = '';
            this.passwordConfirmation = ''; this.dob = '';
            this.checkbox = false; this.checkboxAge = false;
        }
    },
    computed: {
        disabledButton() {
            if (this.isLoading) return true;

            if (
                this.errors.firstName === ''
                && this.errors.lastName === ''
                && this.errors.email === ''
                //&& this.errors.dob === ''
                && this.errors.password === ''
                && (
                    this.firstName.length > 0
                    && this.lastName.length > 0
                    && this.email.length > 0
                    && this.password.length > 0
                    && this.checkbox
                    && this.checkboxAge
                    //&& this.dob.length > 0
                )
            ) {
                return false;
            }

            return true;
        }
    },
    watch: {
        dob(value) {
            this.apiErrors = null;
            if(value >= new Date())
                this.errors.dob = 'Data de naștere este incorectă';
            else this.errors.dob = '';
        },
        "$store._modules.root.state.notification.notification.title"(notification) {
            this.isLoading = false;

            if (Array.isArray(notification)) {
                this.apiErrors = notification;
            } else {
                this.apiErrors = [ notification ];
            }
		}
    }
}
</script>
